export default __webpack_public_path__ + "086cab3b2fd497e6409e396ba8df7cae.png";